(function () {
  'use strict';

  angular
    .module('app.page-projector-employees', []);
})();
